import BaseModel from "./base/baseModel";
import TipoCliente from "./enum/tipoCliente";

export class TipoVendaClienteModel extends BaseModel {
    id?: number = null;
    tipoVendaId = 0;
    tipoCliente: TipoCliente = null;
    tipoClienteDescricao = "";
}
